<template>
  <div class="realtime-log-preview">
    <transition name="realtime-log-ticker">
      <div v-if="log" :key="log.key" class="realtime-log-preview__line">
        <i :style="{ backgroundColor: log.color }"></i>
        <UiTag v-if="log.planeName" tone="neutral" size="mini" class="realtime-log-plane" :title="log.planeName"><span class="ui-tag__text">{{ log.planeName }}</span></UiTag>
        <span class="realtime-log-preview__content">{{ $t(log.content) }}</span>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'GroundStationRealtimeLogPreview',
  props: {
    log: { type: Object, default: null }
  }
}
</script>

<style lang="scss" scoped>
.realtime-log-preview {
  height: 22px;
  min-width: 0;
  position: relative;
  flex: 1 1 0;
  overflow: hidden;
  pointer-events: none;
}

.realtime-log-preview__line {
  width: 100%;
  height: 22px;
  position: absolute;
  inset: 0 auto auto 0;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: var(--ui-space-xs);
  color: var(--ui-text-primary);
  font-size: var(--ui-font-size-caption);
  line-height: 1.35;
  text-shadow: 0 1px 3px var(--ui-bg-page), 0 0 8px var(--ui-bg-page);
}

.realtime-log-preview__line > i {
  width: 6px;
  height: 6px;
  flex: 0 0 6px;
  border-radius: 50%;
  box-shadow: none;
}

.realtime-log-preview__line > .ui-tag { max-width: 50%; flex: 0 1 auto; }
.realtime-log-preview__content { min-width: 0; flex: 1 1 auto; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

.realtime-log-ticker-enter-active,
.realtime-log-ticker-leave-active { transition: opacity .3s ease, transform .3s var(--ui-ease-standard); }
.realtime-log-ticker-enter { opacity: 0; transform: translateY(100%); }
.realtime-log-ticker-leave-to { opacity: 0; transform: translateY(-100%); }

</style>
